import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/builder"
import { Redirect } from "react-router-dom"
import TextArea from "components/TextArea"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import nullToEmptyString from "helpers/nullToEmptyString"
import _ from "lodash"
import Title from "../general/title"
import matchModel from "helpers/matchModel"
import { toast } from "react-toastify"
import ColorPicker from "components/ColorPicker"
import HTMLEditor from "components/HTMLEditor"
import TableRowField from "components/TableRowField"
import settings from "settings"

class EditBuilder extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			modal: false,
			fields,
		}
	}

	componentDidMount() {
		if (this.props.payloadStatus) {
			let id = parseInt(this.props.match.params.id)
			let builder = _.find(this.props.payload.public.builders, { id: id })
			builder = nullToEmptyString(builder)
			let f = matchModel(fields, builder)
			this.setState({ fields: f })
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.payloadStatus !== this.props.payloadStatus) {
			let id = parseInt(this.props.match.params.id)
			let builder = _.find(this.props.payload.public.builders, { id: id })
			builder = nullToEmptyString(builder)
			let f = matchModel(fields, builder)
			this.setState({ fields: f })
		}
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			properties: Yup.array()
				.min(1, "Please choose at least one property.")
				.typeError("Please choose at least one property.")
				.required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			return (
				<div>
					<Title title="Edit Builder" showDate={false} />
					<div className="content">
						<h3 />
						<Formik
							enableReinitialize
							validateOnMount={true}
							initialValues={this.state.fields}
							validationSchema={this.validation}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("updateBuilder", values).then((data) => {
									//return
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div>
									{console.log(f)}
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("properties", f)}>
												<label htmlFor="properties">
													Properties <sup>*</sup>
												</label>
												{f.errors.properties && f.touched.properties && (
													<div className="form__message">{f.errors.properties}</div>
												)}
												<ReactSelect
													name={`properties`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													isMulti
													value={f.values.properties}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("code", f)}>
												<label htmlFor="code">
													Code for Lot Status Map <sup>*</sup>
												</label>
												{f.errors.code && f.touched.code && (
													<div className="form__message">{f.errors.code}</div>
												)}
												<Field name="code" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("marketing_name", f)}>
												<label htmlFor="marketing_name">Marketing Name</label>
												{f.errors.marketing_name && f.touched.marketing_name && (
													<div className="form__message">{f.errors.marketing_name}</div>
												)}
												<Field name="marketing_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("color", f)}>
												<label htmlFor="color">
													Color{" "}
													<span className="small">
														<i
															className={`fas fa-info-circle`}
															style={{ marginRight: 5 }}
														/>
														Hex Code
													</span>
												</label>
												{f.errors.color && f.touched.color && (
													<div className="form__message">{f.errors.color}</div>
												)}
												<Field name="color" type="text" className="form__input" />
												<ColorPicker
													name={`color`}
													value={f.values.color}
													onChange={(v) => f.setFieldValue("color", v)}
												/>
											</li>
											<li className={fieldStatus("legal_name", f)}>
												<label htmlFor="legal_name">Legal Name</label>
												{f.errors.legal_name && f.touched.legal_name && (
													<div className="form__message">{f.errors.legal_name}</div>
												)}
												<Field name="legal_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("has_feed", f)}>
												<label htmlFor="has_feed">Has Feed</label>
												{f.errors.has_feed && f.touched.has_feed && (
													<div className="form__message">{f.errors.has_feed}</div>
												)}
												<ReactSelect
													name={`has_feed`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.has_feed}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("type", f)}>
												<label htmlFor="type">Type</label>
												{f.errors.type && f.touched.type && (
													<div className="form__message">{f.errors.type}</div>
												)}
												<ReactSelect
													name={`type`}
													options={[
														{ value: "Production", label: "Production" },
														{ value: "Custom", label: "Custom" },
														{ value: "Semi-Custom", label: "Semi-Custom" },
													]}
													value={f.values.type}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("btr", f)}>
												<label htmlFor="btr">Build To Rent?</label>
												{f.errors.btr && f.touched.btr && (
													<div className="form__message">{f.errors.btr}</div>
												)}
												<ReactSelect
													name={`btr`}
													options={[
														{ label: "No", value: 0 },
														{ label: "Yes", value: 1 },
													]}
													value={f.values.btr}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("notes", f)}>
												<label htmlFor="notes">Notes</label>
												{f.errors.notes && f.touched.notes && (
													<div className="form__message">{f.errors.notes}</div>
												)}
												<TextArea
													name="notes"
													className="form__textarea"
													value={f.values.notes}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.notes}
													error={f.errors.notes}
												/>
											</li>
											{settings.lotContracts && (
												<>
													<li className={fieldStatus("finance_name", f)}>
														<label htmlFor="finance_name">Finance Name</label>
														{f.errors.finance_name && f.touched.finance_name && (
															<div className="form__message">{f.errors.finance_name}</div>
														)}
														<Field
															name="finance_name"
															type="text"
															className="form__input"
														/>
													</li>
													<li className={fieldStatus("finance_address", f)}>
														<label htmlFor="finance_address">Finance Address</label>
														{f.errors.finance_address && f.touched.finance_address && (
															<div className="form__message">
																{f.errors.finance_address}
															</div>
														)}
														<Field
															name="finance_address"
															type="text"
															className="form__input"
														/>
													</li>
													<li className={fieldStatus("finance_city", f)}>
														<label htmlFor="finance_city">Finance City</label>
														{f.errors.finance_city && f.touched.finance_city && (
															<div className="form__message">{f.errors.finance_city}</div>
														)}
														<Field
															name="finance_city"
															type="text"
															className="form__input"
														/>
													</li>
													<li className={fieldStatus("finance_state", f)}>
														<label htmlFor="finance_state">Finance State</label>
														{f.errors.finance_state && f.touched.finance_state && (
															<div className="form__message">
																{f.errors.finance_state}
															</div>
														)}
														<ReactSelect
															name="finance_state"
															options={this.props.payload.public.states}
															className="form__input"
															value={f.values.finance_state}
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.finance_state}
															error={f.errors.finance_state}
														/>
													</li>
													<li className={fieldStatus("finance_zip", f)}>
														<label htmlFor="finance_zip">Finance Zip</label>
														{f.errors.finance_zip && f.touched.finance_zip && (
															<div className="form__message">{f.errors.finance_zip}</div>
														)}
														<Field name="finance_zip" type="text" className="form__input" />
													</li>
													<li className={fieldStatus("land_bank.finance_name", f)}>
														<label htmlFor="land_bank.finance_name">
															Land Bank Finance Name
														</label>
														{f.errors.land_bank?.finance_name &&
															f.touched.land_bank?.finance_name && (
																<div className="form__message">
																	{f.errors.land_bank?.finance_name}
																</div>
															)}
														<Field
															name="land_bank.finance_name"
															type="text"
															className="form__input"
														/>
													</li>
													<li className={fieldStatus("land_bank.finance_address", f)}>
														<label htmlFor="land_bank.finance_address">
															Land Bank Finance Address
														</label>
														{f.errors.land_bank?.finance_address &&
															f.touched.land_bank?.finance_address && (
																<div className="form__message">
																	{f.errors.land_bank?.finance_address}
																</div>
															)}
														<Field
															name="land_bank.finance_address"
															type="text"
															className="form__input"
														/>
													</li>
													<li className={fieldStatus("land_bank.finance_city", f)}>
														<label htmlFor="land_bank.finance_city">
															Land Bank Finance City
														</label>
														{f.errors.land_bank?.finance_city &&
															f.touched.land_bank?.finance_city && (
																<div className="form__message">
																	{f.errors.land_bank?.finance_city}
																</div>
															)}
														<Field
															name="land_bank.finance_city"
															type="text"
															className="form__input"
														/>
													</li>
													<li className={fieldStatus("land_bank.finance_state", f)}>
														<label htmlFor="land_bank.finance_state">
															Land Bank Finance State
														</label>
														{f.errors.land_bank?.finance_state &&
															f.touched.land_bank?.finance_state && (
																<div className="form__message">
																	{f.errors.land_bank?.finance_state}
																</div>
															)}
														<ReactSelect
															name="land_bank.finance_state"
															options={this.props.payload.public.states}
															className="form__input"
															value={f.values.land_bank?.finance_state}
															onChange={f.setFieldValue}
															onBlur={f.setFieldTouched}
															touched={f.touched.land_bank?.finance_state}
															error={f.errors.land_bank?.finance_state}
														/>
													</li>
													<li className={fieldStatus("land_bank.finance_zip", f)}>
														<label htmlFor="land_bank.finance_zip">
															Land Bank Finance Zip
														</label>
														{f.errors.land_bank?.finance_zip &&
															f.touched.land_bank?.finance_zip && (
																<div className="form__message">
																	{f.errors.land_bank?.finance_zip}
																</div>
															)}
														<Field
															name="land_bank.finance_zip"
															type="text"
															className="form__input"
														/>
													</li>
												</>
											)}

											<li className={fieldStatus("marketing_description", f, null, null, true)}>
												<label htmlFor="marketing_description">Marketing Description</label>
												{f.errors.marketing_description && f.touched.marketing_description && (
													<div className="form__message">
														{f.errors.marketing_description}
													</div>
												)}
												<div className="form__bigHTML">
													<HTMLEditor
														name={"marketing_description"}
														className="form__textarea"
														value={f.values.marketing_description}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
													/>
												</div>
											</li>
											{settings?.enabled?.floorplanCollections && (
												<li
													className={fieldStatus(
														"floorplan_collections",
														f,
														false,
														false,
														true
													)}>
													<div className="reportGroup">
														<h3>Floorplan Collections</h3>
														<TableRowField
															fields={[
																{
																	type: "text",
																	name: "name",
																	header: "Name",
																},
																{
																	type: "select",
																	name: "lot_type",
																	lookup: "lot_types",
																	header: "Lot Types",
																},
															]}
															data={f.values.floorplan_collections}
															delete={true}
															onChange={(v) =>
																f.setFieldValue("floorplan_collections", v)
															}
														/>
													</div>
												</li>
											)}
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						</Formik>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditBuilder)
